
import { useEffect, useState } from 'react';
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import NotificationHandler from '../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../utils/Enum';

const File = ({ item, setItem, activeAccordion, validations }) => {
    console.log("itemFile", item)
    console.log("validationItemsModal itemFilevalidations", validations)
    const { handleFileChange, handleRemoveFile } = useNewItemChange(setItem, 'Viewer', activeAccordion);

    const [imagePreview, setFilePreview] = useState('');
    const [dragActive, setDragActive] = useState(false);

    useEffect(() => {
        if (item.file) {
            setFilePreview(item.file)
        } else {
            setFilePreview('');
        }
    }, [item.file])

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        setDragActive(false);
        if (!file) return; // Ensure a file is dropped

        if (!file.type.startsWith("image/") && file.type !== "application/pdf") { // || file.type === "image/svg+xml"
            NotificationHandler('Only images and PDFs are allowed.', enumUtil.enumtoaster.error)
            return;
        }
        // Check if the dropped file is an image
        let asEvent = { target: { files: [file] } };
        handleFileChange(asEvent, item);
    };;


    return (
        <div className='content-box d-flex gap-10 align-items-center'>
            <p className={`text text-black w-231px flex-shrink-0 d-flex  justify-content-end gap-01 text-end ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                {item.content || '[Enter prompt or question]'}
                {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
            </p>
            <div className={`input w-100 ${validations?.isInvalid ? 'error' : ''}`}>
                {item?.answer ?
                    (<div className='d-flex align-items-center justify-content-between form-control'>
                        <p className='text text-black singleLine-ellispis w-100'>{item?.answer}</p>
                        <i className='icon-x-cros fs-14 dark-clr' onClick={() => handleRemoveFile(item)}></i>
                    </div>)
                    :
                    (<div className={`upload-file form-control align-items-center h-100 d-flex align-items-center p-0 ${dragActive ? 'opacity-50' : ''}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <input
                            type="file"
                            id={`PatientFile-${item.ItemID}`}
                            name={`PatientFile-${item.ItemID}`}
                            onChange={e => handleFileChange(e, item)}
                            accept="image/*,application/pdf"// Allow only images
                            multiple={false} // Ensures only one file
                        />

                        <label className="w-100 d-block px-2" htmlFor={`PatientFile-${item.ItemID}`}>
                            {/* <label  className='justify-content-start fst-italic light-clrs h-100'>{item?.name ? item.file.name : 'Click to upload file'} */}
                            <p className='f-11 ar-light-color text fst-normal' htmlFor={`PatientFile-${item.ItemID}`}>Upload your picture</p>
                        </label>
                    </div>)
                }
            </div>
        </div>
    )

}

export default File;